import React from 'react';
import { LanguageProvider, useLanguage } from './context/LanguageContext';
import { LanguageSplash } from './components/barber/LanguageSplash';
import { BarberLanding } from './pages/BarberLanding';
function AppContent() {
  const {
    language
  } = useLanguage();
  return <>
      {/* Always mount the landing so it loads in the background */}
      <div className="barber-pole-left" data-id="element-0" />
      <div className="barber-pole-right" data-id="element-1" />
      <BarberLanding data-id="element-2" />

      {/* Splash sits on top until language is chosen */}
      {language === null && <LanguageSplash data-id="element-3" />}
    </>;
}
export function App() {
  return <LanguageProvider data-id="element-4">
      <AppContent data-id="element-5" />
    </LanguageProvider>;
}